<template>
  <div class="ai-badge" :class="`ai-badge--${tone}`">
    <v-icon small class="mr-2" :color="iconColor">{{ icon }}</v-icon>
    <span class="ai-badge__title">Абонемент AI-эксперта</span>
    <template v-if="summary">
      <span v-if="summary.plan" class="ai-badge__item grey--text text--darken-1">{{ summary.plan }}</span>
      <span v-if="untilText || canSend" class="ai-badge__item">{{ untilText ? `до ${untilText}` : 'без срока окончания' }}</span>
      <span class="ai-badge__item">{{ requestsText }}</span>
      <span v-if="!canSend && summary.reason" class="ai-badge__item ai-badge__reason">{{ summary.reason }}</span>
    </template>
    <span v-else-if="failed" class="ai-badge__item">Не удалось получить данные абонемента</span>
    <span v-else class="ai-badge__item grey--text">Загрузка…</span>
    <v-btn v-if="failed" x-small text color="primary" class="ml-2" @click="load">Повторить</v-btn>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { canSendQuestion } from '@/store/ai/expert';

// Сводка: allowed, plan, end_at (null у бессрочных), remaining_requests (null у безлимита), unlimited_requests
const UNTIL_FIELDS = ['end_at'];

// Состояние абонемента пользователя: до какого числа и сколько запросов осталось (GET /ai-expert/usage/summary/).
export default {
  name: 'AiSubscriptionBadge',
  computed: {
    ...mapGetters({
      summary: 'ai/expert/summary',
      failed: 'ai/expert/summaryError',
    }),
    canSend() {
      return canSendQuestion(this.summary);
    },
    untilText() {
      if (!this.summary) return '';
      const key = UNTIL_FIELDS.find((f) => this.summary[f]);
      const date = key ? moment(this.summary[key]) : null;
      return date && date.isValid() ? date.format('DD.MM.YYYY') : '';
    },
    requestsText() {
      const { summary } = this;
      if (summary.unlimited_requests) return 'запросов без ограничений';
      const left = Number(summary.remaining_requests);
      return Number.isFinite(left) ? `осталось запросов: ${left}` : 'остаток запросов неизвестен';
    },
    tone() {
      if (this.failed || !this.summary) return 'neutral';
      return this.canSend ? 'ok' : 'blocked';
    },
    icon() {
      return this.tone === 'blocked' ? 'mdi-alert-circle-outline' : 'mdi-ticket-confirmation-outline';
    },
    iconColor() {
      return { ok: 'success', blocked: 'error', neutral: 'grey' }[this.tone];
    },
  },
  methods: {
    ...mapActions({ load: 'ai/expert/loadEnabled' }),
  },
};
</script>

<style scoped lang="scss">
.ai-badge {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;
  padding: 8px 14px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  font-size: 14px;

  &--ok {
    border-color: #c8e6c9;
    background: #f6fbf6;
  }

  &--blocked {
    border-color: #ffcdd2;
    background: #fff7f7;
  }

  &__title {
    font-weight: 600;
  }

  &__reason {
    color: #c62828;
  }
}
</style>
